import { FaTruck, FaHeadphones, FaShieldAlt } from "react-icons/fa";
import { SiHackthebox } from "react-icons/si";
import React from "react";

const Services = () => {
  const features = [
    {
      icon: FaTruck,
      title: "Free Shipping",
      description: "Free shipping on all your order",
    },
    {
      icon: FaHeadphones,
      title: "Customer Support 24/7",
      description: "Instant access to Support",
    },
    {
      icon: FaShieldAlt,
      title: "100% Secure Payment",
      description: "We ensure your money is safe",
    },
    {
      icon: SiHackthebox,
      title: "Money-Back Guarantee",
      description: "30 Days Money-Back Guarantee",
    },
  ];

  return (
    <div className="w-full bg-[#FFF1F1] shadow-lg px-4 sm:px-6 lg:px-8">
      <div className="w-full mx-auto hidden lg:block">
        <div className="flex flex-wrap justify-center items-center gap-4">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-3 p-4 flex-1 min-w-[200px] transition-all"
              >
                <div>
                  <IconComponent className="text-orange-500" size={24} />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900 tracking-wide">
                    {feature.title}
                  </h3>
                  {/* <p className="text-sm text-gray-500">{feature.description}</p> */}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-full mx-auto block sm:hidden">
        <div className="flex flex-wrap justify-center items-center gap-3 px-0 py-1">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-1 p-0 flex-1 min-w-[25px]"
              >
                <div>
                  <IconComponent className="text-orange-500" size={8} />
                </div>
                <h3 className="text-[6px] font-medium text-gray-800">
                  {feature.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Services;
